import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"overflow":"scroll"} }
const _hoisted_2 = { class: "table table-striped table-hover" }
const _hoisted_3 = ["width", "onClick"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "fas fa-sort-up"
}
const _hoisted_6 = {
  key: 1,
  class: "fas fa-sort-down"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onMouseover", "innerHTML"]
const _hoisted_9 = ["onClick", "innerHTML"]
const _hoisted_10 = { class: "pagination" }
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", null, "表示ページ:" + _toDisplayString(_ctx.currentPage) + "/" + _toDisplayString(_ctx.total), 1),
    _createElementVNode("span", null, "表示数:" + _toDisplayString(_ctx.inPageCount), 1),
    _createElementVNode("span", null, "データ総数:" + _toDisplayString(_ctx.rows.length), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
            return (_openBlock(), _createElementBlock("th", {
              key: col.index,
              width: col.width,
              onClick: ($event: any) => (_ctx.sort(col, $event))
            }, [
              _createElementVNode("span", {
                innerHTML: col.label
              }, null, 8, _hoisted_4),
              (col.up)
                ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                : _createCommentVNode("", true),
              (col.down)
                ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                : _createCommentVNode("", true)
            ], 8, _hoisted_3))
          }), 128))
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inPageRows, (row, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: row.index
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: col.index,
                  class: _normalizeClass(_ctx.cellCss(col)),
                  onClick: ($event: any) => (_ctx.onSelectRow(row, $event))
                }, [
                  (col.type === 'date')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.display(row, col))), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (col.type === 'currency')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.formatCurrency(_ctx.display(row, col))), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (col.type === 'renderfunc')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        onMouseover: ($event: any) => (col.onmouseover && col.onmouseover(row, col, $event)),
                        innerHTML: col.representedAs(row)
                      }, null, 40, _hoisted_8))
                    : _createCommentVNode("", true),
                  (!col.type || col.type === 'none')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createTextVNode(_toDisplayString(_ctx.display(row, col)), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (col.type === 'seq')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _createTextVNode(_toDisplayString(index + 1), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (col.btnClass)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 5,
                        class: _normalizeClass(col.btnClass),
                        onClick: ($event: any) => {
                  col.onclick(row, $event);
                  $event.stopPropagation();
                },
                        innerHTML: col.label
                      }, null, 10, _hoisted_9))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_7))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("ul", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginations, (index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "page-item"
        }, [
          _createElementVNode("button", {
            class: "page-link",
            onClick: ($event: any) => (_ctx.currentPage = index + 1)
          }, _toDisplayString(index + 1), 9, _hoisted_11)
        ]))
      }), 128))
    ])
  ]))
}